import { createFileRoute } from '@tanstack/react-router'
import { InvoiceScreen } from '@/features/invoices/routes/invoice-screen'

export const Route = createFileRoute('/invoices/$invoiceId')({ component: InvoicePage })

function InvoicePage() {
  const { invoiceId } = Route.useParams()
  return <InvoiceScreen invoiceId={invoiceId} />
}
